<template>
  <TransitionGroup class="toasts" name="toast" tag="ul">
    <Toast v-for="toast in toastStore.toasts" :key="toast.id" :toast="toast" />
  </TransitionGroup>
</template>

<script setup lang="ts">
  import Toast from '@/components/global/Toast.vue';

  import { useToastStore } from '@/stores/toast';
  const toastStore = useToastStore();
</script>

<style lang="scss">
.toasts {
  @include mixins.flex-center($horiz: flex-start, $gap: 16px);
  flex-direction: column;
}

.toast-enter-from,
.toast-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.toast-enter-active,
.toast-leave-active {
  transition: 0.25s ease all;
}
</style>